export default __webpack_public_path__ + "static/media/support_room_welcome_finish.9f48bce2.png";